export enum ActionStatus {
  New,
  NeedConfirm,
  Confirmed,
  Accepted,
  CanceledConfirming,
  CanceledAccepting,
}
